import { createContext, useRef, useState } from "react";
import Notification from "../../../../components/toast";
import reqProduto from "../../../../services/reqMultiTenant/reqProduto";

const ContextRegisterProduct = createContext({});

const RegisterProductProvider = (props) => {
	const [isOpenModalRegister, setIsOpenModalRegister] = useState(false);
	const [isOpenModalFilter, setIsOpenModalFilter] = useState(false);
	const [isOpenModalVariants, setIsOpenModalVariants] = useState(false);
	const [parentProduct, setParentProduct] = useState(null);

	const [id_produto, setId_produto] = useState(0);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [productsData, setProductsData] = useState([]);
	const [filterData, setFilterData] = useState([]);

	//Controle de paginação
	const [page, setPage] = useState(1); //page
	const [totalPage, setTotalPage] = useState(0); // endPage // indica que chegou ao fim as pesquisas -> pensar caso adicionar mais e passar para a proxima pagina
	const currentPage = useRef(0); //total Paginas Listadas

	const [loading, setLoading] = useState(false);

	//#region Handle Modal
	const handleOpenModalRegister = (item) => {
		let id = 0;

		if (item?.id_produto) id = item.id_produto;

		setId_produto(id);
		setSelectedProduct(item ?? null);
		setIsOpenModalRegister(true);
	};

	const handleOpenModalFilter = () => {
		setIsOpenModalFilter(true);
	};
	const handleCloseModalRegister = () => {
		setIsOpenModalRegister(false);
		setSelectedProduct(null);
	};
	const handleCloseModalFilter = () => {
		setIsOpenModalFilter(false);
	};
	const handleOpenModalVariants = (item) => {
		setParentProduct(item);
		setIsOpenModalVariants(true);
	};
	const handleCloseModalVariants = () => {
		setIsOpenModalVariants(false);
		setParentProduct(null);
	};
	//#endregion

	//#region Fetch
	const firstFetch = async (filterSelected) => {
		try {
			const response = await fetchProduct(filterSelected, 1);
			const data = response.data || [];

			const recordCount = data.length;

			setProductsData(data);

			// Se a quantidade de itens retornados for menor que 15, está na última página
			if (recordCount < 15) {
				setTotalPage(1);
			} else {
				setTotalPage(0);
				currentPage.current = 1;
			}

			// Atualizar filtro com o número de registros encontrados
			const filter = { ...filterSelected, recordCount };
			setFilterData(filter);

			setPage(1);
			handleCloseModalFilter();
		} catch (error) {
			setProductsData([]);
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		}
	};

	const nextFetch = async (newPage) => {
		try {
			setLoading(true);

			if (totalPage > 0) return;

			const response = await fetchProduct(filterData, newPage);
			const data = response.data || [];

			if (data.length > 0) {
				setProductsData((prevDate) => [...prevDate, ...data]);
			}

			// se não encontrou nada ou a quantidade de itens retornados for menor que 15, está na última página
			if (data.length === 0 || data.length < 15) {
				setTotalPage(currentPage.current + 1);
			} else {
				currentPage.current++;
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	const fetchProduct = async (filterData, newPage, perPage = 15) => {
		const { param, paramValue, active, tipoproduto } = filterData;

		let ativo = "NAO";
		if (active === true) ativo = "SIM";

		const responseProduct = await reqProduto.listPaginate(
			param,
			paramValue,
			ativo,
			newPage,
			tipoproduto ?? "pai",
			perPage
		);

		// setProductsData(responseProduct.data);
		return responseProduct;
	};

	// busca o resultado completo da pesquisa (mesmos filtros), sem paginação, usado para gerar o relatório
	const fetchAllProducts = async (filterSelected) => {
		const response = await fetchProduct(filterSelected, 1, 100000);
		return response.data || [];
	};

	//#endregion

	return (
		<ContextRegisterProduct.Provider
			value={{
				id_produto,
				setId_produto,
				selectedProduct,
				loading,

				//control modal
				isOpenModalRegister,
				isOpenModalFilter,
				isOpenModalVariants,
				parentProduct,
				handleOpenModalRegister,
				handleOpenModalFilter,
				handleOpenModalVariants,
				handleCloseModalFilter,
				handleCloseModalRegister,
				handleCloseModalVariants,

				//fetch and data
				productsData,
				filterData,
				setProductsData,
				firstFetch,
				nextFetch,
				fetchAllProducts,

				//paginate
				page,
				totalPage,
				currentPage,
				setPage,
			}}
		>
			{props.children}
		</ContextRegisterProduct.Provider>
	);
};

export { RegisterProductProvider, ContextRegisterProduct };
